import { isDefinedString, isPositiveNumber } from "et3-type-guards";

import getCoreLayoutStore from "../../stores/core/core-layout-store";
import CollapsibleChevron from "../et3-collapsible/CollapsibleChevron";
import CollapsibleCount from "../et3-collapsible/CollapsibleCount";
import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import {
  SURFACE_BORDER,
  SURFACE_HEADER_BACKGROUND
} from "../et3-theme/surface-constants";
import {
  SECTION_HEADER_HEIGHT,
  SECTION_HEADER_PADDING,
  SECTION_SUMMARY_FONT_SIZE,
  SECTION_TITLE_FONT_SIZE,
  SECTION_TITLE_GAP
} from "./section-constants";

const SectionHeader = withLiteObserverAndTheme<{
  title: string;
  summary: string;
  count: number;
  sectionId: string;
  defaultOpen: boolean;
  isCollapsible: boolean;
  width: number;
}>((props) => {
  const {
    title,
    summary,
    count,
    sectionId,
    defaultOpen,
    isCollapsible,
    width,
    theme
  } = props;
  const { colors, unitX } = theme;
  const isOpen = getCoreLayoutStore().isSectionOpen(sectionId, defaultOpen);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={width}
      height={SECTION_HEADER_HEIGHT}
      fDirection="row"
      alignItems="center"
      justifyContent="flex-start"
      color={SURFACE_HEADER_BACKGROUND}
      style={{
        boxSizing: "border-box",
        width: "100%",
        paddingLeft: SECTION_HEADER_PADDING * unitX,
        paddingRight: SECTION_HEADER_PADDING * unitX,
        gap: SECTION_TITLE_GAP * unitX,
        borderBottom: isOpen ? SURFACE_BORDER : "none",
        cursor: isCollapsible ? "pointer" : "default"
      }}
      onClick={() => {
        if (isCollapsible) {
          getCoreLayoutStore().toggleSection(sectionId, defaultOpen);
        }
      }}
    >
      {isCollapsible ? <CollapsibleChevron isOpen={isOpen} /> : null}
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={SECTION_TITLE_FONT_SIZE}
        text={title}
        isSpan={true}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0 }}
      />
      {isPositiveNumber(count) ? <CollapsibleCount count={count} /> : null}
      {isDefinedString(summary) ? (
        <Et3Text
          fontFamily={"LIGHT"}
          fontSize={SECTION_SUMMARY_FONT_SIZE}
          text={summary}
          isSpan={true}
          color={colors.all.davysGrey}
          style={{ margin: 0 }}
        />
      ) : null}
    </ET3Div>
  );
});
export default SectionHeader;
